<template>
  <footer class="footer1">
    <!-- FOOTER TOP -->
    <div class="row footer-top">
      <div class="container">
        <div class="row">
          <div class="col-md-12 footer-row-1">
            <div class="row">
              <div class="col-md-6 sidebar-1">
                <aside id="custom_html-2" class="widget_text widget widget_custom_html">
                  <div class="textwidget custom-html-widget">
                    <div class="logo">
                      <a href="/">
                        <img
                          src="../../assets/images/logo-footer.png"
                          alt="logo-footer"
                        />
                      </a>
                    </div>
                  </div>
                </aside>
                <aside id="custom_html-3" class="widget_text widget widget_custom_html">
                  <div class="textwidget custom-html-widget">
                    <p class="footer-description">
                      We are the world’s first-ever AI based content removal service
                      provider. We take care about your cyber content and privacy
                      providing solutions for individuals and businesses.
                    </p>
                    <hr class="footer-line" />
                  </div>
                </aside>
                <aside id="custom_html-4" class="widget_text widget widget_custom_html">
                  <div class="textwidget custom-html-widget">
                    <p class="footer-newsletter-info">
                      Join Our Newsletter &amp; Communication We'll send you news and
                      offers.
                    </p>
                    <p
                      v-if="newsletteremailError"
                      style="color: #f78a8a; padding: 14px 0px; margin-bottom: -15px"
                    >
                      Invalid email address. Please enter valid email address
                    </p>
                    <p
                      v-if="newsletteremailFailed"
                      style="color: #f78a8a; padding: 14px 0px; margin-bottom: -15px"
                    >
                      Cannot subscribe to newsletter. Please try again.
                    </p>
                    <p
                      v-if="newsletteremailSuccess"
                      style="color: #81da9e; padding: 14px 0px; margin-bottom: -15px"
                    >
                      Successfully Subscribed!
                    </p>
                  </div>
                </aside>
                <aside id="mc4wp_form_widget-2" class="widget widget_mc4wp_form_widget">
                  <form
                    id="mc4wp-form-1"
                    class="mc4wp-form mc4wp-form-116"
                    method="post"
                    data-id="116"
                    data-name="Newsletter"
                    action="https://staging.clearmeout.com/newsletter.php"
                    @submit.prevent="subscribe"
                    novalidate="novalidate"
                  >
                    <div class="mc4wp-form-fields">
                      <div class="newsletter-hostcluester">
                        <input
                          v-model="newsletteremail"
                          name="email"
                          placeholder="Insert your email"
                          required
                          type="email"
                        />
                        <input
                          value="Send"
                          id="formsubmit"
                          type="button"
                          v-on:click="subscrbe"
                        />
                      </div>
                    </div>
                    <label>
                      Leave this field empty if you're human:
                      <input
                        name="_mc4wp_honeypot"
                        tabindex="-1"
                        autocomplete="off"
                        type="text"
                      />
                    </label>
                    <input name="_mc4wp_timestamp" value="1531471709" type="hidden" />
                    <input name="_mc4wp_form_id" value="116" type="hidden" />
                    <input
                      name="_mc4wp_form_element_id"
                      value="mc4wp-form-1"
                      type="hidden"
                    />
                    <div class="mc4wp-response"></div>
                  </form>
                  <!-- / MailChimp for WordPress Plugin -->
                </aside>
                <aside
                  id="hostcluster_address_social_icons-2"
                  class="widget widget_hostcluster_address_social_icons"
                >
                  <div class="sidebar-social-networks address-social-links">
                    <ul class="social-links">
                      <li>
                        <a href="https://www.facebook.com/clearmeoutcom/" target="_blank">
                          <i class="fa fa-facebook"></i>
                        </a>
                      </li>
                      <li>
                        <a href="https://twitter.com/clearmeoutcom" target="_blank">
                          <i class="fa fa-twitter"></i>
                        </a>
                      </li>
                      <!-- <li>
                        <a href="http://plus.google.com/">
                          <i class="fa fa-google-plus"></i>
                        </a>
                      </li>
                      <li>
                        <a href="https://www.linkedin.com/">
                          <i class="fa fa-linkedin"></i>
                        </a>
                      </li> -->
                      <li>
                        <a href="https://www.instagram.com/clear.me.out/" target="_blank">
                          <i class="fa fa-instagram"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </aside>
                <aside id="custom_html-5" class="widget_text widget widget_custom_html">
                  <div class="textwidget custom-html-widget">
                    <hr class="footer-line" />
                    <p>
                      <a class="footer-info1" href="tel:+61383720177"
                        >+ 61 (39) 0216735</a
                      >
                    </p>
                    <p>hello@clearmeout.com</p>
                  </div>
                </aside>
              </div>
              <div class="col-md-3 sidebar-2">
                <aside id="nav_menu-2" class="widget widget_nav_menu">
                  <h1 class="widget-title">Services</h1>
                  <div class="menu-domain-container">
                    <ul id="menu-domain-1" class="menu">
                      <li
                        class="menu-item menu-item-type-custom menu-item-object-custom menu-item-89"
                      >
                        <a href="/personal">Personal</a>
                      </li>
                      <li
                        class="menu-item menu-item-type-custom menu-item-object-custom menu-item-90"
                      >
                        <a href="/business">Business</a>
                      </li>
                      <li
                        class="menu-item menu-item-type-custom menu-item-object-custom menu-item-91"
                      >
                        <a href="/pricing">Plans &amp; Pricing</a>
                      </li>
                    </ul>
                  </div>
                </aside>
                <aside id="nav_menu-6" class="widget widget_nav_menu">
                  <h1 class="widget-title">Company</h1>
                  <div class="menu-resellers-container">
                    <ul id="menu-resellers" class="menu">
                      <li
                        class="menu-item menu-item-type-custom menu-item-object-custom menu-item-95"
                      >
                        <a href="/about">About Us</a>
                      </li>
                      <li
                        class="menu-item menu-item-type-custom menu-item-object-custom menu-item-96"
                      >
                        <a href="/technology">Technology</a>
                      </li>
                      <li
                        class="menu-item menu-item-type-custom menu-item-object-custom menu-item-96"
                      >
                        <a href="https://staging.clearmeout.com/blog">Blog</a>
                      </li>
                      <li
                        class="menu-item menu-item-type-custom menu-item-object-custom menu-item-96"
                      >
                        <a href="/press">Press</a>
                      </li>
                      <li
                        class="menu-item menu-item-type-custom menu-item-object-custom menu-item-96"
                      >
                        <a href="/contact-us">Contact Us</a>
                      </li>
                    </ul>
                  </div>
                </aside>
                <aside id="nav_menu-7" class="widget widget_nav_menu">
                  <h1 class="widget-title">Legal</h1>
                  <div class="menu-legals-container">
                    <ul id="menu-legals-1" class="menu">
                      <li
                        class="menu-item menu-item-type-custom menu-item-object-custom menu-item-97"
                      >
                        <a href="/terms-of-service">Terms of Service</a>
                      </li>
                      <li
                        class="menu-item menu-item-type-custom menu-item-object-custom menu-item-98"
                      >
                        <a href="/privacy-policy">Privacy Policy</a>
                      </li>
                    </ul>
                  </div>
                </aside>
              </div>
              <div class="col-md-3 sidebar-3">
                <aside id="nav_menu-3" class="widget widget_nav_menu">
                  <h1 class="widget-title">Account</h1>
                  <div class="menu-hosting-container">
                    <ul id="menu-hosting-1" class="menu">
                      <li
                        class="menu-item menu-item-type-custom menu-item-object-custom menu-item-101"
                      >
                        <a href="/personal_sign_in">Personal Account</a>
                      </li>
                      <li
                        class="menu-item menu-item-type-custom menu-item-object-custom menu-item-101"
                      >
                        <a href="/business_sign_in">Business Account</a>
                      </li>
                      <li
                        class="menu-item menu-item-type-custom menu-item-object-custom menu-item-102"
                      >
                        <a href="/signup">Create Personal Account</a>
                      </li>
                    </ul>
                  </div>
                </aside>
                <aside id="nav_menu-4" class="widget widget_nav_menu">
                  <h1 class="widget-title">Support</h1>
                  <div class="menu-support-container">
                    <ul id="menu-support" class="menu">
                      <li
                        class="menu-item menu-item-type-custom menu-item-object-custom menu-item-107"
                      >
                        <a href="/support">Support Center</a>
                      </li>
                      <li
                        class="menu-item menu-item-type-custom menu-item-object-custom menu-item-110"
                      >
                        <a href="/faq">FAQ</a>
                      </li>
                    </ul>
                  </div>
                </aside>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 footer-row-2">
            <div class="row"></div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 footer-row-3">
            <div class="row"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- FOOTER BOTTOM -->
    <div class="row footer-div-parent">
      <div class="footer">
        <p class="copyright text-center">
          Copyright &#x40; {{ date }} Clear Me Out Company. All Rights Reserved.
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
var axios = require("axios");

const config = {
  headers: {
    "Content-Type": "application/json",
    Host: "https://staging.clearmeout.com",
    Authorization: "Basic a2V5OjAwZjNkOTRjZWMyOGEzMWIxMDdlNzJjN2E2ZmY3MGU0LXVzMg==",
  },
};
export default {
  data() {
    return {
      date: new Date().toISOString().substr(0, 4),
      newsletteremail: "",
      newsletteremailError: false,
      newsletteremailSuccess: false,
      newsletteremailFailed: false,
      info: null,
    };
  },
  methods: {
    subscrbe: function (e) {
      this.newsletteremailSuccess = false;

      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (!re.test(String(this.newsletteremail).toLowerCase())) {
        this.newsletteremailError = true;
        return;
      }

      const $this = this;
      this.newsletteremailError = false;

      jQuery
        .post("https://staging.clearmeout.com/newsletter.php", {
          email: this.newsletteremail,
        })
        .done(function (data) {
          $this.newsletteremail = "";
          $this.newsletteremailSuccess = true;

          setTimeout(() => {
            $this.newsletteremailSuccess = false;
          }, 5000);
        })
        .fail(function (xhr, status, error) {
          $this.newsletteremailFailed = true;
          $this.newsletteremail = "";
          setTimeout(() => {
            $this.newsletteremailFailed = false;
          }, 5000);
        });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/common/footer.vue